/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbayConnectUrlResp
 */
export interface AdminEbayConnectUrlResp {
    /**
     * 
     * @type {string}
     * @memberof AdminEbayConnectUrlResp
     */
    url: string;
}

export function AdminEbayConnectUrlRespFromJSON(json: any): AdminEbayConnectUrlResp {
    return AdminEbayConnectUrlRespFromJSONTyped(json, false);
}

export function AdminEbayConnectUrlRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayConnectUrlResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function AdminEbayConnectUrlRespToJSON(value?: AdminEbayConnectUrlResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

